var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTop4Creator = function SvgTop4Creator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2FA",
    fillRule: "evenodd",
    d: "M21.735.269a1.96 1.96 0 0 1 1.38.571c1.641 1.645 6.368 6.375 8.01 8.018.366.367.571.861.572 1.379-.002 2.323-.004 9.01-.003 11.334a1.96 1.96 0 0 1-.572 1.38c-1.645 1.642-6.375 6.369-8.018 8.011-.367.366-.861.57-1.379.571-2.323-.002-9.01-.003-11.334-.003a1.96 1.96 0 0 1-1.38-.572C7.37 29.313 2.643 24.583 1 22.941a1.96 1.96 0 0 1-.571-1.38c.002-2.323.003-9.01.003-11.334a1.96 1.96 0 0 1 .572-1.38C2.649 7.207 7.379 2.48 9.021.838c.367-.366.862-.571 1.38-.572 2.323.002 9.01.004 11.334.004",
    clipRule: "evenodd"
  })));
};
export default SvgTop4Creator;